import React, { useState, useEffect } from "react";
import Fab from "@mui/material/Fab";
import { useMediaQuery } from "@mui/material";
import TabContext from "context/TabContext";
import { useContext } from "react";

const FloatingActionButtons = () => {
  const [isVisible, setIsVisible] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const { enquiryFormRef } = useContext(TabContext);
  const [formRef] = enquiryFormRef;

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isMobile || !isVisible) {
    return null;
  }

  return (
    <>
      <div
        style={{
          position: "fixed",
          bottom: "0px",
          left: "0",
          right: "0",
          zIndex: 999,
          backgroundColor: "#fff",
          padding: "16px",
          height: "5.5rem",
          borderRadius: "16px 16px 0 0",
          display: "flex",
          opacity: 0.9,
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Fab
          aria-label="open-menu"
          onClick={() => window.scrollTo({ top: 350, behavior: "smooth" })}
          style={{
            position: "fixed",
            bottom: "16px",
            right: "16px",
            zIndex: 1000,
            backgroundColor: "#7A5AF8",
            fontFamily: "Ping AR + LT",
          }}
        >
          <i
            className="bi bi-calculator"
            style={{ fontSize: "24px", color: "#fff" }}
          ></i>
        </Fab>

        <Fab
          aria-label="lets-connect"
          onClick={() =>{
            if (formRef.current) {
              const offset = 156; // Adjust this value as needed
              const topPosition = formRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
              window.scrollTo({
                top: topPosition,
                behavior: 'smooth'
              });
            }
            // formRef?.current?.scrollIntoView({
            //   behavior: "smooth",
            //   block: "start",
            // })
          }}
          style={{
            position: "fixed",
            bottom: "16px",
            left: "16px",
            zIndex: 1000,
            background: "linear-gradient(92deg, #221AFB 4.13%, #140F95 96.55%)",
            borderRadius: "33px",
            padding: "12px 16px",
            width: "fit-content",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span
            style={{
              fontSize: "16px",
              color: "#fff",
              fontWeight: "bold",
              textTransform: "none",
              display: "flex",
              alignItems: "center",
            }}
          >
            <i
              className="bi bi-telephone"
              style={{
                fontSize: "24px",
                color: "#fff",
                marginRight: "8px",
              }}
            />
            Let's Connect
          </span>
        </Fab>
      </div>
    </>
  );
};

export default FloatingActionButtons;
